import { PropertyCategoryIdentifierEnum } from 'common/data/property-category/identifier.enum';

/**
 * Mapping language identifier to language label
 */
const mapping: { [key in PropertyCategoryIdentifierEnum]: string } = {
  [PropertyCategoryIdentifierEnum.residentialForSale]: 'Residential for Sale',
  [PropertyCategoryIdentifierEnum.residentialForRent]: 'Residential for Rent',
  [PropertyCategoryIdentifierEnum.commercialForSale]: 'Commercial for Sale',
  [PropertyCategoryIdentifierEnum.commercialForRent]: 'Commercial for Rent',
};

export function propertyGetCategory(identifier: PropertyCategoryIdentifierEnum): string {
  if (!identifier) {
    return;
  }

  return mapping[identifier];
}
